var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSearch = function SvgIcSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 18a7.47 7.47 0 0 0 4.596-1.573 1 1 0 0 0 .197.28l4 4a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-.28-.197A7.5 7.5 0 1 0 10.5 18m5.5-7.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcSearch;